import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

/**
 * Every pillar opens with the same eyebrow / headline / lead block. Sharing one
 * wrapper reveals the block once on entry so the page arrives in beats rather
 * than all at once. Motion is skipped when the user asks for reduced motion.
 *
 * There is deliberately no rule above the eyebrow: the eyebrow is already a
 * small, coloured, letterspaced line of type — a second orange mark above it
 * was decoration announcing a label that announces itself.
 */
export function SectionIntro({
  children,
  className = '',
  align = 'center'
}: {
  children: React.ReactNode;
  className?: string;
  align?: 'center' | 'left';
}) {
  const reduce = useReducedMotion();
  return <motion.div initial={reduce ? false : {
    opacity: 0,
    y: 18
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.35
  }} transition={{
    duration: 0.6,
    ease: [0.23, 1, 0.32, 1]
  }} className={className} data-id="element-1060" data-mp="167v4jdxmuisj">
      {children}
    </motion.div>;
}